<template>
  <div class="contact-us full-screen">
    <nav class="navbar navbar-ct-default" role="navigation-demo">
      <div class="container">
        <!-- Brand and toggle get grouped for better mobile display -->
        <!-- <div class="navbar-header">
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link :to="{path:'/'}" class="navbar-brand">Site title</router-link>
        </div> -->

        <!-- Collect the nav links, forms, and other content for toggling -->
        <!-- <div class="collapse navbar-collapse" id="navigation-example-2">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link :to="{path:'/'}">Home</router-link>
            </li>
          </ul>
        </div> -->
        <!-- /.navbar-collapse -->
      </div>
      <!-- /.container-->
    </nav>
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container mt-4" id="mensaje-condicional">
    <div class="row">
      <div class="col-12 text-center justify-content-center">
        <div class="col-6 px-auto mx-auto">
          <img src="../../public/LogopricipalChami.png" alt="Imagen de acceso a la web de citas" class="img-fluid object-fit-cover mb-3">
        </div>
        
        <h1 class="display-4" style="color: black !important;">¡Para acceder a esta web de citas debes usar la app!</h1>
        <p class="lead" style="color: black !important;">Descarga la app desde tu tienda de aplicaciones favorita y disfruta de todas las funciones.</p>
      </div>
    </div>
  </div>
      </div>
    </div>
    <footer class="footer-demo">
      <div class="container">
        <nav class="pull-left">
          <!-- <ul>
            <li>
              <router-link :to="{path:'/'}">Home</router-link>
            </li>
            <li>
              <router-link :to="{path:'/register'}">Register</router-link>
            </li>
          </ul> -->
        </nav>
        <!-- <div class="copyright text-center">
          &copy; Coded with
          <i class="fa fa-heart heart"></i> by
          <a href="https://binarcode.com" target="_blank">BinarCode</a>.
          Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>.
        </div> -->
      </div>
    </footer>
  </div>
</template>

<script>
  export default {}

</script>
